import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount: number, currency?: string): string {
  const currencySymbols: { [key: string]: string } = {
    'INR': '₹',
    'USD': '$',
    'EUR': '€',
    'GBP': '£',
    'JPY': '¥',
    'CAD': 'C$',
    'AUD': 'A$',
    'CHF': 'CHF',
    'CNY': '¥',
    'SEK': 'kr',
    'NOK': 'kr',
    'DKK': 'kr',
    'PLN': 'zł',
    'CZK': 'Kč',
    'HUF': 'Ft',
    'RUB': '₽',
    'BRL': 'R$',
    'MXN': '$',
    'KRW': '₩',
    'SGD': 'S$',
    'HKD': 'HK$',
    'NZD': 'NZ$',
    'ZAR': 'R',
    'TRY': '₺',
    'ILS': '₪',
    'AED': 'د.إ',
    'SAR': '﷼',
    'QAR': '﷼',
    'KWD': 'د.ك',
    'BHD': 'د.ب',
    'OMR': '﷼',
    'JOD': 'د.ا',
    'LBP': 'ل.ل',
    'EGP': '£',
    'MAD': 'د.م.',
    'TND': 'د.ت',
    'DZD': 'د.ج',
    'LYD': 'ل.د',
    'SDG': 'ج.س.',
    'ETB': 'Br',
    'KES': 'KSh',
    'UGX': 'USh',
    'TZS': 'TSh',
    'MWK': 'MK',
    'ZMW': 'ZK',
    'BWP': 'P',
    'SZL': 'L',
    'LSL': 'L',
    'NAD': 'N$',
    'MUR': '₨',
    'SCR': '₨',
    'MVR': 'ރ',
    'LKR': '₨',
    'BDT': '৳',
    'NPR': '₨',
    'PKR': '₨',
    'AFN': '؋',
    'IRR': '﷼',
    'IQD': 'د.ع',
    'SYP': '£',
    'YER': '﷼',
    'THB': '฿',
    'VND': '₫',
    'IDR': 'Rp',
    'MYR': 'RM',
    'PHP': '₱',
    'MMK': 'K',
    'LAK': '₭',
    'KHR': '៛',
    'BND': 'B$',
    'FJD': 'FJ$',
    'PGK': 'K',
    'SBD': 'SI$',
    'VUV': 'Vt',
    'WST': 'WS$',
    'TOP': 'T$',
    'NIO': 'C$',
    'GTQ': 'Q',
    'HNL': 'L',
    'SVC': '$',
    'BZD': 'BZ$',
    'JMD': 'J$',
    'TTD': 'TT$',
    'BBD': 'Bds$',
    'XCD': '$',
    'AWG': 'ƒ',
    'ANG': 'ƒ',
    'SRD': '$',
    'GYD': 'G$',
    'VES': 'Bs',
    'COP': '$',
    'PEN': 'S/',
    'BOB': 'Bs',
    'CLP': '$',
    'ARS': '$',
    'UYU': '$U',
    'PYG': '₲',
    'GMD': 'D',
    'GHS': '₵',
    'NGN': '₦',
    'XOF': 'CFA',
    'XAF': 'FCFA',
    'CDF': 'FC',
    'AOA': 'Kz',
    'MZN': 'MT',
    'ZWL': 'Z$',
    'BIF': 'FBu',
    'DJF': 'Fdj',
    'KMF': 'CF',
    'RWF': 'RF',
    'SOS': 'S',
    'TJS': 'SM',
    'UZS': 'лв',
    'KGS': 'лв',
    'KZT': '₸',
    'TMT': 'T',
    'UAH': '₴',
    'BYN': 'Br',
    'MDL': 'L',
    'RON': 'lei',
    'BGN': 'лв',
    'RSD': 'дин',
    'MKD': 'ден',
    'ALL': 'L',
    'HRK': 'kn',
    'BAM': 'КМ',
    'ISK': 'kr',
    'LVL': 'Ls',
    'LTL': 'Lt',
    'EEK': 'kr',
    'MTL': '₤',
    'CYP': '£',
    'SIT': 'SIT',
    'SKK': 'Sk',
    'CSK': 'Kčs',
    'YUM': 'дин',
    'DEM': 'DM',
    'FRF': '₣',
    'ITL': '₤',
    'ESP': '₧',
    'PTE': '$',
    'IEP': '£',
    'NLG': 'ƒ',
    'BEF': '₣',
    'LUF': '₣',
    'ATS': 'S',
    'FIM': 'mk',
    'GRD': '₯',
    'ADP': '₧',
    'SML': '₤',
    'VAT': '₤',
    'MCF': '₣',
    'MTP': '₤'
  };

  const currencyCode = currency || 'INR'; // Default to INR if currency is undefined
  const symbol = currencySymbols[currencyCode.toUpperCase()] || currencyCode;
  return `${symbol} ${amount.toLocaleString()}`;
}